$(function () {
    $('form').submit(function () {
        if (!$(this).attr('data-notdisabledonsubmit')) {
            $(this).find($('input[type="submit"]')).attr('disabled', 'disabled');
            $(this).find($('button[type="submit"]')).attr('disabled', 'disabled');
        }
    });
});